import React from 'react'
import {
    Button, Typography, Dialog, DialogTitle, DialogContent, IconButton, Stack
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';


const EmailPreview = ({ open, onClose, selectedPreview ,questions,jobTitle}) => {
    return (
        <>
            <Dialog open={open} onClose={onClose}>
                <Stack direction={"row"} justifyContent={"space-between"}>
                    <DialogTitle sx={{ fontWeight: 700, fontSize: 25 }}>{selectedPreview.type} Preview</DialogTitle>
                    <IconButton onClick={onClose}><CloseIcon /></IconButton>
                </Stack>
                <DialogContent>
                    <Typography variant="body1">
                        <strong>From:</strong> Aaxcel
                    </Typography>
                    <Typography variant="body1">
                        <strong>To:</strong> Candidate
                    </Typography>
                    <Typography variant="body1">
                        <strong>Subject:</strong>  Axcel has {selectedPreview.event} you to a video interview - Next steps
                    </Typography>
                    <DialogContent dividers sx={{ maxHeight: '350px', overflowY: 'auto' }}>
                        <Typography variant="body1" paragraph>
                            Hi, {`candidate name`} I hope this finds you well.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Thank you for your interest in Axcel. We’d like to invite you to take a brief video-interview for our ({jobTitle}) position.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            The interview has {questions?.length} questions and will only take you a few minutes. We request you to please take it within the next {selectedPreview?.trigger}. It's a good idea to take the interview in a quiet room with good internet connection and good lighting.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Follow this link to start the interview:
                        </Typography>
                        <Typography variant="body1" paragraph>
                           interview Url
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Note: You can take the interview using the link above on the Chrome browser, on any laptop, or smartphone. If using an iPhone, you can take it on Safari or the Axcel app.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Let me know if you had any question.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Good luck!
                        </Typography>
                        <Typography variant="body1">
                            Wynce Low, <br />
                            Axcel
                        </Typography>
                    </DialogContent>

                </DialogContent>
            </Dialog>
        </>
    )
}

export default EmailPreview;
